import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';

import ShareVisibilityIcon from '../ShareVisibilityIcon';
import { IconToggle } from './styles';

const ICON_SIZE = { width: 20, height: 20 };

export default function ShareButton({
  hasPublicData, changes, title, onShare,
}) {
  const label = title || (hasPublicData ? 'Share changes' : 'Share');

  // An empty diff share stays visible, but stops being a button.
  if (hasPublicData && changes === 'none') {
    return (
      <Box title={label} sx={{ display: 'inline-flex', alignItems: 'center', p: '8px' }}>
        <ShareVisibilityIcon isPublic changes="none" style={ICON_SIZE} />
      </Box>
    );
  }

  return (
    <IconToggle type="button" onClick={onShare} title={label}>
      <ShareVisibilityIcon isPublic={hasPublicData} changes={changes} style={ICON_SIZE} />
    </IconToggle>
  );
}

ShareButton.propTypes = {
  hasPublicData: PropTypes.bool,
  changes: PropTypes.oneOf(['unknown', 'some', 'none']),
  title: PropTypes.string,
  onShare: PropTypes.func,
};

ShareButton.defaultProps = {
  hasPublicData: false,
  changes: 'unknown',
  title: '',
  onShare: null,
};
